export default {
    confirm: 'Yes, delete now',
    content: 'You are deleting the innovation field for all participants.',
    notice: 'Attention: This action cannot be undone.',
    success: 'The innovation field was successfully deleted.',
    title: 'Are you sure you want to delete the innovation field "{title}" ?'
}
